module.exports = __webpack_public_path__ + "static/media/06.77d4922d.png";